<template lang="html">
  <div>
    <v-container fluid :class="[{ 'mb-12': isLastRefresh }]">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <div class="d-flex align-center">
            <h2 class="headline">
              <span class="font-weight-bold d-flex align-center">
                <v-icon class="mr-3 black--text" @click="goBack()">
                  mdi-arrow-left
                </v-icon>
                {{ $t('your_order') }}
              </span>
            </h2>
            <v-spacer />
            <span v-if="!isHotels" class="__self-tag">
              {{ order.order_no }}
            </span>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <template v-if="order.remark === 'DELIVERY' && !$isEmpty(order.shipping_log) && (order.shipping_courier_id === 'S08' || order.shipping_courier_id === 'S09')">
            <div style="margin: 0px -12px;">
              <div class="container-map-delivery">
                <div v-if="order.shipping_log && !$isEmpty(order.shipping_log.shipper) && ((order.shipping_courier_id === 'S08' && order.shipping_log.shipper.status_code === '1180') || (order.shipping_courier_id === 'S09' && order.shipping_log.shipper.status_code === '1170'))" class="overlay">
                  <div class="text-view">
                    <v-btn color="primary" small class="text-none" @click="dialog.tracking = true">
                      Track
                    </v-btn>
                  </div>
                </div>
                <l-map ref="map" v-resize="onResize" :zoom="13" :center="center" style="height: 100%; width: 100%; z-index: 1;">
                  <l-tile-layer :url="url" :attribution="attribution" />
                  <l-marker :lat-lng="markerLatLng">
                    <l-icon>
                      <div class="marker-destination">
                        <img src="@/assets/images/svg/destination.svg">
                      </div>
                    </l-icon>
                  </l-marker>
                  <l-marker :lat-lng="markerLatLngStore">
                    <l-icon>
                      <div class="marker-store">
                        <img src="@/assets/images/marker_store.svg">
                      </div>
                    </l-icon>
                  </l-marker>
                </l-map>
              </div>
              <div>
                <div v-if="order.shipping_log && !$isEmpty(order.shipping_log.shipper) && order.shipping_log.shipper.status_code === '999'" class="container-no-driver shadow-top">
                  <div class="no-driver-wrap">
                    <div class="no-driver-icon">
                      <v-icon large color="primary">
                        mdi-alert-circle-outline
                      </v-icon>
                    </div>
                    <div class="no-driver-content">
                      <div class="no-driver-title primary--text">
                        {{ order.shipping_log.shipper.status_description }}
                      </div>
                      <div class="no-driver-subtitle">
                        {{ $t('contact_restaurant_to_confirm_order') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div :class="[`container-store`, { 'shadow-top': order.shipping_log && !$isEmpty(order.shipping_log.shipper) && order.shipping_log.shipper.status_code !== '2000' }]">
                  <div class="soft-black--text font-weight-bold font-16">
                    {{ order.store_name }}
                  </div>
                  <v-spacer />
                  <div class="d-flex">
                    <v-btn text icon outlined :href="'tel:' + order.store_phone_1" class="delivery-icon-store mr-2">
                      <img src="@/assets/images/delivery_call.png" alt="Call">
                    </v-btn>
                    <v-btn text icon outlined :href="'https://wa.me/' + order.store_setting_whatsapp" class="delivery-icon-store">
                      <img src="@/assets/images/delivery_whatsapp.png" alt="Whatsapp">
                    </v-btn>
                  </div>
                </div>
                <div v-if="shipperProcess && (order.status === 'A' || order.status === 'S')" class="status-gosend order-sending">
                  <div class="detail-status primary--text font-weight-bold">
                    <v-icon v-if="shipperProcess" small color="primary" class="mr-1">
                      mdi-check-circle
                    </v-icon>
                    {{ $t('status.processing') }}
                  </div>
                  <hr :class="[`line-horizontal`, { 'primary': outForDelivery }]">
                  <div :class="[`detail-status`, { 'primary--text font-weight-bold': outForDelivery }]">
                    <v-icon v-if="outForDelivery" small color="primary" class="mr-1">
                      mdi-check-circle
                    </v-icon>
                    {{ $t('status.delivery') }}
                  </div>
                  <hr :class="[`line-horizontal`, { 'primary': isDelivered }]">
                  <div :class="['detail-status', { 'primary--text font-weight-bold': isDelivered }]">
                    <v-icon v-if="isDelivered" small color="primary" class="mr-1">
                      mdi-check-circle
                    </v-icon>
                    {{ $t('status.received') }}
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-if="isHotels">
            <div class="card-hotel mb-4">
              <div class="card-content-list">
                <div class="card-content-text">
                  <div class="card-content-title">
                    {{ order.table_no }}
                  </div>
                </div>
              </div>
            </div>
            <div class="card-hotel mb-6">
              <div class="card-content-list">
                <div class="card-content-text">
                  <div class="card-content-subtitle">
                    {{ $t('order_number') }}
                  </div>
                  <div class="card-content-title">
                    {{ order.order_no }}
                  </div>
                  <div class="card-content-subdesc">
                    <span v-if="order.status === 'A' || order.status === 'S'" class="status--text">
                      {{ order.shipping_log && !$isEmpty(order.shipping_log.shipper) && order.shipping_log.shipper.status_description ? order.shipping_log.shipper.status_description : order.status_desc }}
                    </span>
                    <span v-else :class="[`font-weight-bold`, { 'status--text': order.status !== 'X', 'red--text': order.status === 'X' }]">
                      {{ order.status_desc }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="hotel-notes">
              <div class="d-flex align-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M8.6543 1.84392C8.85676 1.6865 9.1199 1.63094 9.36816 1.69255L16.0352 3.35857C16.4059 3.45108 16.6669 3.78474 16.667 4.16716V15.8342C16.6669 16.2166 16.4067 16.5503 16.0352 16.6427L9.36816 18.3088C9.30164 18.3254 9.23435 18.3341 9.16699 18.3342C8.98288 18.3342 8.80261 18.2732 8.6543 18.1574C8.4518 17.9999 8.33301 17.7568 8.33301 17.5002V16.6672H5C4.53923 16.6672 4.1671 16.2941 4.16699 15.8342V4.16716C4.16706 3.70722 4.53921 3.33416 5 3.33416H8.33301V2.50017C8.33315 2.24367 8.45192 2.00133 8.6543 1.84392ZM10 16.4328L15 15.1828V4.81853L10 3.56853V16.4328ZM5.83301 5.00017V15.0002H8.33301V5.00017H5.83301ZM10.833 9.84392C10.833 9.30154 11.3424 8.90372 11.8682 9.03435C12.2389 9.12684 12.4999 9.46053 12.5 9.84295V10.1574C12.5 10.5399 12.2398 10.8727 11.8682 10.966C11.3424 11.0968 10.8332 10.6999 10.833 10.1584V9.84392Z" fill="#767676" />
                </svg>
              </div>
              <div class="hotel-notes-content">
                <div class="hotel-notes-title">
                  {{ order.notes }}
                </div>
                <div class="hotel-notes-subtitle">
                  {{ $t('custom.hotel.room_number') }}
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <v-list class="br-0">
              <v-list-item>
                <v-list-item-avatar size="40" :tile="order.remark === 'DELIVERY' && order.shipping_delivery_type === '2' && (order.shipping_courier_id === 'S08' || order.shipping_courier_id === 'S09')" :class="[`align-self-start mt-3`, { ' order_history_avatar primary': order.remark !== 'DELIVERY' || order.shipping_delivery_type === '1' }]">
                  <template v-if="order.remark === 'RESERVATION'">
                    <v-img src="@/assets/images/svg/order_reservation.svg" contain />
                  </template>
                  <template v-else-if="order.remark === 'OL-TAKE-AWAY'">
                    <v-img src="@/assets/images/svg/order_takeaway.svg" contain />
                  </template>
                  <template v-else-if="order.remark === 'DELIVERY'">
                    <v-img v-if="order.shipping_delivery_type === '1' || !order.shipping_courier_id" src="@/assets/images/svg/order_delivery.svg" contain />
                    <v-img v-else-if="order.shipping_delivery_type === '2' && order.shipping_courier_id === 'S08'" src="@/assets/images/delivery_gosend.png" contain />
                    <v-img v-else-if="order.shipping_delivery_type === '2' && order.shipping_courier_id === 'S09'" src="@/assets/images/delivery_grab.png" contain />
                  </template>
                  <template v-else-if="order.remark === 'OL-DINE-IN'">
                    <v-img src="@/assets/images/svg/order_dinein.svg" contain />
                  </template>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title v-if="isTMII" class="font-weight-bold">
                    <span>
                      {{ order.store_name }}
                    </span>
                  </v-list-item-title>
                  <v-list-item-title class="font-weight-bold">
                    <span>
                      {{ order.remark }}
                    </span>
                  </v-list-item-title>
                  <v-list-item-subtitle class="items font-12 mt-1 __white-space-normal">
                    <div class="mb-3">
                      <span class="grey--text">{{ order.forder_date }}</span>
                    </div>
                    <div class="font-12 mb-1">
                      <span v-if="order.status === 'A' || order.status === 'S'" class="status--text">
                        {{ order.shipping_log && !$isEmpty(order.shipping_log.shipper) && order.shipping_log.shipper.status_description ? order.shipping_log.shipper.status_description : order.status_desc }}
                      </span>
                      <span v-else :class="[`font-weight-bold`, { 'status--text': order.status !== 'X', 'red--text': order.status === 'X' }]">
                        {{ order.status_desc }}
                      </span>
                    </div>
                    <!-- <template v-if="!$isEmpty(order.payment_log) && order.payment_log.global_status !== 'Z'">
                      <div class="font-12">
                        <span>{{ formattedTimeLeft }}</span>
                      </div>
                    </template> -->
                    <div v-if="order.notes !== ''" class="font-weight-bold __white-space-normal">
                      {{ order.notes }}
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="align-self-start">
                  <span v-mask-money-only="order.total_amount" class="font-weight-bold font-14" />
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <div v-if="!order.is_paid && order.status !== 'X' && !$isEmpty(order.payment_log) && order.payment_log.payment_source === 'ASTRAPAY-QRIS'" class="mb-4">
              <v-btn large block color="primary" class="text-none letter-spacing-normal font-weight-bold br-8" @click="fetchOrder()">
                {{ $t('check_payment_status') }}
              </v-btn>
            </div>

            <template v-if="order.remark === 'DELIVERY' && !$isEmpty(order.shipping_log) && (order.shipping_courier_id === 'S08' || order.shipping_courier_id === 'S09')">
              <div>
                <div v-if="!$isEmpty(driverDetail) && driverDetail.name && (order.status === 'A' || order.status === 'S')" class="container-driver">
                  <div class="container-driver-wrap">
                    <div class="container-driver-image">
                      <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg" :class="['avatar-driver', { 'gojek': order.shipping_delivery_type === '2' && order.shipping_courier_id === 'S08', 'grab': order.shipping_delivery_type === '2' && order.shipping_courier_id === 'S09' }]">
                        <g clip-path="url(#clip0_4698_7915)">
                          <rect y="0.5" width="40" height="40" rx="20" fill="white" />
                          <mask id="mask0_4698_7915" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="41">
                            <rect y="0.5" width="40" height="40" rx="20" fill="white" />
                          </mask>
                          <g mask="url(#mask0_4698_7915)">
                            <path class="avatar-driver-p1" fill-rule="evenodd" clip-rule="evenodd" d="M25.3421 43.4688C25.3421 43.4688 23.7476 36.7802 26.6716 33.7747C27.802 32.6128 29.0005 32.0001 30.0005 32.7693C31.5005 34.0001 32.8513 35.3808 33.4288 37.8988C34.0136 42.7322 33.5247 48.5113 33.9633 53.6266C34.1278 55.5181 34.6441 59.4421 35.0004 62.1612C33.5247 62.4476 29.7098 63.1842 29.8378 63.1433L29.8149 63.6389C29.0154 61.0472 27.8869 56.9959 27.0737 52.9218C26.0731 47.8293 25.3421 43.4688 25.3421 43.4688Z" fill="#1FAD1F" />
                            <path class="avatar-driver-p2" fill-rule="evenodd" clip-rule="evenodd" d="M19.6085 29.6824L17.21 29.1277C17.21 29.1277 10.5003 32.0001 9.00024 33.0001C7.50022 34.0001 8.66187 34.2521 8.48369 34.4021C8.38637 34.63 8.35321 34.8799 8.38775 35.1251C8.38775 35.2842 8.38774 35.4707 8.41059 35.6798C8.92228 47.4245 11.0696 54.6178 11.4442 68.1085C18.4252 69.2134 23.6564 68.9452 30.8567 68.0449C30.8567 68.0449 31.5329 50.521 31.606 47.6291C31.6791 44.7373 31.638 46.5197 31.6608 45.965C31.7476 43.2368 32.3155 37.7552 32.0002 36.0001C31.5002 34.0001 30.0029 32.7731 29.9978 32.7698C28.5002 31.5001 25.9995 30.6845 24.1498 29.3778L23.7341 29.7415C22.3616 29.6343 20.9836 29.6145 19.6085 29.6824Z" fill="#1FAD1F" />
                            <path class="avatar-driver-p3" fill-rule="evenodd" clip-rule="evenodd" d="M17.4792 25.7583L17.2142 29.1276C17.2142 29.1276 17.1457 30.9464 18.8909 32.7651C20.6362 34.5839 23.2678 34.0746 23.9577 32.3559C24.6475 30.6372 24.2044 29.7641 24.2044 29.7641L23.4734 26.845L17.4792 25.7583Z" fill="#FDCC98" />
                            <path class="avatar-driver-p4" fill-rule="evenodd" clip-rule="evenodd" d="M17.479 25.7583L17.2734 28.3591C18.6727 29.291 20.3465 29.7266 22.0249 29.5959C22.7177 29.5401 23.3991 29.387 24.0489 29.1412L23.4732 26.8405L17.479 25.7583Z" fill="#D7A26B" />
                            <path class="avatar-driver-p5" fill-rule="evenodd" clip-rule="evenodd" d="M27.5803 13.4407C27.5803 13.4407 27.8818 19.5791 26.4975 23.6577C25.1132 27.7363 24.1263 28.8912 20.3343 28.0318C16.5422 27.1725 14.6965 23.0984 14.6965 23.0984C14.6965 23.0984 12.54 23.9578 11.4664 22.1117C10.3927 20.2657 11.4207 18.4196 12.2385 18.3787C12.3326 18.3675 12.4277 18.3675 12.5218 18.3787C13.0827 18.4578 13.6158 18.6716 14.0751 19.0016C13.7479 17.5426 13.843 16.0212 14.3492 14.6138C14.3492 14.6138 14.2899 10.9763 16.7478 10.1397C19.2058 9.30302 21.9242 10.1397 21.9242 10.1397C21.9242 10.1397 21.9562 10.3852 21.9973 10.7126L27.16 10.8717C27.499 11.6838 27.6429 12.5635 27.5803 13.4407Z" fill="#FDCC98" />
                            <path class="avatar-driver-p6" fill-rule="evenodd" clip-rule="evenodd" d="M24.9993 19.8848C25.1778 19.9228 25.3635 19.9042 25.531 19.8318C25.6985 19.7593 25.8395 19.6365 25.9346 19.4803C26.0297 19.324 26.0741 19.142 26.0618 18.9594C26.0495 18.7767 25.9811 18.6024 25.866 18.4604C25.7508 18.3184 25.5947 18.2158 25.419 18.1666C25.2433 18.1174 25.0567 18.1241 24.885 18.1858C24.7132 18.2475 24.5648 18.3611 24.4601 18.511C24.3554 18.6609 24.2995 18.8397 24.3003 19.0227C24.2811 19.2297 24.3435 19.436 24.4742 19.5972C24.605 19.7584 24.7935 19.8617 24.9993 19.8848Z" fill="#272727" />
                            <path class="avatar-driver-p7" fill-rule="evenodd" clip-rule="evenodd" d="M19.7024 19.9507C19.8809 19.9887 20.0667 19.9701 20.2342 19.8977C20.4017 19.8252 20.5427 19.7024 20.6377 19.5462C20.7328 19.3899 20.7772 19.208 20.7649 19.0253C20.7526 18.8426 20.6842 18.6683 20.5691 18.5263C20.4539 18.3843 20.2978 18.2817 20.1221 18.2325C19.9464 18.1833 19.7598 18.19 19.5881 18.2517C19.4164 18.3134 19.2679 18.427 19.1632 18.5769C19.0585 18.7268 19.0027 18.9056 19.0034 19.0887C18.9842 19.2956 19.0466 19.5019 19.1774 19.6631C19.3081 19.8243 19.4966 19.9276 19.7024 19.9507Z" fill="#272727" />
                            <path class="avatar-driver-p8" fill-rule="evenodd" clip-rule="evenodd" d="M21.0659 15.7733L20.9791 16.3916C20.028 16.3858 19.0816 16.5269 18.1739 16.81L18.1328 16.0097C18.1328 16.0097 19.9101 15.314 21.0659 15.7733Z" fill="#272727" />
                            <path class="avatar-driver-p9" fill-rule="evenodd" clip-rule="evenodd" d="M23.7695 15.6049V16.3006C24.6108 16.2766 25.4465 16.4429 26.2138 16.7871L26.4834 16.1232C25.6516 15.683 24.7059 15.5024 23.7695 15.6049Z" fill="#272727" />
                            <path class="avatar-driver-p10" fill-rule="evenodd" clip-rule="evenodd" d="M24.602 23.2303C23.3662 23.4755 22.097 23.5048 20.8511 23.3167C18.8911 22.9939 18.4571 22.5437 18.4571 22.5437C18.4571 22.5437 17.3789 24.9263 20.3531 25.7266C23.3273 26.5268 24.5609 25.14 24.602 23.2303Z" fill="#CB3638" />
                            <path class="avatar-driver-p11" fill-rule="evenodd" clip-rule="evenodd" d="M24.5147 23.2484C23.309 23.4767 22.0731 23.4998 20.8597 23.3166C19.3155 23.0619 18.717 22.73 18.5342 22.5981C18.4931 22.9028 18.589 23.403 19.416 23.9395C20.7409 24.7989 23.5781 24.7352 24.236 23.7894C24.3528 23.6223 24.4465 23.4403 24.5147 23.2484Z" fill="white" />
                            <path class="avatar-driver-p12" fill-rule="evenodd" clip-rule="evenodd" d="M22.7698 19.7019C22.8096 20.0435 22.9371 20.3692 23.1399 20.6477C23.5145 21.266 23.4825 21.8026 23.0713 22.1391C22.7566 22.3422 22.3772 22.4216 22.0068 22.3619C22.2578 22.4477 22.525 22.476 22.7885 22.4445C23.0519 22.413 23.3048 22.3226 23.5282 22.18C24.1313 21.6844 23.615 20.7522 23.2998 20.3339C23.1386 20.1109 22.9615 19.8997 22.7698 19.7019Z" fill="#D7A26B" />
                            <path class="avatar-driver-p13" fill-rule="evenodd" clip-rule="evenodd" d="M12.2524 19.4927C12.5472 19.554 12.8211 19.69 13.0476 19.8876C13.2742 20.0851 13.4456 20.3375 13.5454 20.6203C13.6432 20.8902 13.6739 21.1796 13.6349 21.4639C13.5959 21.7481 13.4884 22.0187 13.3215 22.2527C13.3215 22.2527 12.5722 22.4527 12.1702 21.2342C12.1702 21.2342 13.0611 21.3387 13.0611 20.9431C13.0611 20.5476 12.0057 20.3475 12.0012 20.3475C11.9817 20.1955 11.994 20.0411 12.0372 19.894C12.0805 19.7469 12.1537 19.6103 12.2524 19.4927Z" fill="#D7A26B" />
                            <path class="avatar-driver-p14" fill-rule="evenodd" clip-rule="evenodd" d="M11.9233 16.1553C11.9918 16.469 12.074 16.7873 12.17 17.1056C12.3063 17.523 12.4176 17.9482 12.5035 18.3787C13.0644 18.4578 13.5975 18.6716 14.0569 19.0016C14.1745 19.1314 14.2591 19.2873 14.3036 19.4563C14.3238 19.5538 14.3375 19.6526 14.3447 19.7519L14.966 19.8383C14.8703 19.3442 14.835 18.8403 14.861 18.3378C14.8748 17.8163 15.0683 17.3154 15.4092 16.9191C15.4092 16.9191 16.0077 16.7782 16.4417 14.8685C16.6707 13.5628 16.5638 12.2207 16.1311 10.9672L17.1956 11.1764L18.1504 11.5219C19.7936 11.8197 21.4601 11.9719 23.1303 11.9766C24.3471 12.0077 25.5629 11.8855 26.7488 11.6129C27.0133 12.113 27.2261 12.6386 27.3838 13.1816C27.4885 13.5288 27.5604 13.885 27.5986 14.2455V15.2731C27.5986 15.4414 27.5986 15.6187 27.5986 15.7688C27.5986 16.2826 27.5711 16.6781 27.5711 16.6781L27.8955 15.7688C28.1566 14.5745 28.2214 13.3461 28.0874 12.1312C28.0235 11.5901 27.9595 11.1627 27.9001 10.8353C27.8403 10.7103 27.7732 10.5888 27.6991 10.4716C26.8584 9.13933 25.6066 7.67977 21.8785 7.05684C18.1504 6.43391 14.9341 7.89348 14.1391 8.75285C13.3441 9.61222 12.9741 10.0851 12.9741 10.0851C12.9741 10.0851 12.3253 10.4716 11.8502 12.2722C11.586 13.5606 11.6109 14.8912 11.9233 16.1689V16.1553Z" fill="#272727" />
                            <path class="avatar-driver-p15" fill-rule="evenodd" clip-rule="evenodd" d="M11.5993 32.6607C11.8406 32.6828 12.0802 32.7208 12.3166 32.7744C12.8191 34.2203 13.6004 36.5211 14.144 38.2853C12.5359 40.927 8.4377 43.5643 8.4377 43.5643L1.64858 48.2476L6.61936 52.7945L3.81873 56.9686C0.689152 54.5496 -3.86587 50.9167 -4.63341 49.7617C-5.93093 47.8338 -3.51408 45.3012 -1.59521 42.8549C0.433123 40.2627 4.13543 36.0764 8 33.4999C9.5 32.4999 10.6236 32.6299 11.5993 32.6607Z" fill="#1FAD1F" />
                            <path class="avatar-driver-p16" fill-rule="evenodd" clip-rule="evenodd" d="M11.5439 15.7824C11.617 14.3274 11.7587 10.5762 12.0785 10.0442C12.3983 9.51222 14.3903 6.96139 16.9899 6.14749C19.5895 5.33359 22.6825 5.2381 24.5008 6.18386C26.3192 7.12962 27.9502 8.87565 27.9502 9.44401C27.9502 10.0124 28.5213 14.2774 28.5213 14.2774C28.5213 14.2774 21.5083 14.4184 17.8442 14.773C15.7231 14.9633 13.6179 15.3006 11.5439 15.7824Z" fill="#178217" />
                            <path class="avatar-driver-p17" fill-rule="evenodd" clip-rule="evenodd" d="M20.5631 5.52446C21.9102 5.4209 23.2624 5.64726 24.5013 6.18376C26.3288 7.09315 27.9507 8.87555 27.9507 9.44391C27.9507 10.0123 28.5218 14.2773 28.5218 14.2773C28.5218 14.2773 21.5088 14.4183 17.8447 14.7729C16.5198 14.9002 15.3319 15.073 14.3496 15.2276C14.4227 13.1497 14.578 10.0577 14.907 9.59396C15.405 8.87554 17.2188 6.00188 20.5631 5.52446Z" fill="#178217" />
                            <path class="avatar-driver-p18" fill-rule="evenodd" clip-rule="evenodd" d="M16.1771 14.1818C15.5389 14.4741 14.9275 14.821 14.3496 15.2185C14.3496 15.2185 19.7179 15.7096 21.7601 15.7733C23.8023 15.8369 23.5876 14.6865 27.0826 14.3319C28.4115 14.1382 29.7683 14.3374 30.9843 14.9048C31.327 15.1139 31.6285 15.2867 31.7702 15.3595C31.8889 15.4231 31.9758 15.4595 32.0306 15.4368C32.1768 15.4368 32.1494 15.3049 32.1357 15.2367C32.122 15.1685 31.5143 14.0409 29.5954 13.2133C27.6766 12.3858 25.4196 11.8993 21.7464 12.5086C18.0731 13.1178 16.1771 14.1818 16.1771 14.1818Z" fill="#1FAD1F" />
                          </g>
                        </g>
                        <rect class="avatar-driver-r1" x="1" y="1.5" width="38" height="38" rx="19" stroke="#1FAD1F" stroke-width="2" />
                        <defs>
                          <clipPath id="clip0_4698_7915">
                            <rect y="0.5" width="40" height="40" rx="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div class="container-driver-content">
                      <div class="container-driver-name">
                        {{ driverDetail.name }}
                      </div>
                      <div v-if="typeof driverDetail.vehicle_number !== 'undefined' && driverDetail.vehicle_number" class="container-driver-subtitle">
                        {{ driverDetail.vehicle_number }}
                      </div>
                    </div>
                    <div v-if="typeof driverDetail.phone !== 'undefined' && driverDetail.phone" class="container-driver-action">
                      <v-btn text icon outlined :href="'tel:' + driverDetail.phone">
                        <img src="@/assets/images/delivery_call.png" alt="Call">
                      </v-btn>
                    </div>
                  </div>
                </div>

                <div v-if="showSearchDriver" class="container-find-driver mb-3">
                  <div class="container-find-driver-content">
                    {{ $t('finding_driver') }}
                  </div>
                  <div class="dot-flashing" />
                </div>
              </div>
            </template>
          </template>

          <div v-if="!$isEmpty(order.payment_log) && order.payment_log.payment_type === 'QRIS' && order.is_paid === 0 && (order.status_inquiry === 1 || order.status_inquiry === 2 || order.status_inquiry === 3 || order.status_inquiry === 4)" class="mb-4">
            <div>
              <v-card class="br-8 shadow-low mb-4">
                <div>
                  <div class="d-flex align-center pa-4">
                    <div class="order-qris-icon mr-4 cursor-pointer" @click="dialog.dialogQrisImage = true">
                      <img :src="order.payment_log.qr_image" alt="">
                    </div>
                    <div>
                      <div class="order-qris-title">
                        {{ $t('pay_with_qris') }}
                      </div>
                      <div class="order-qris-subtitle cursor-pointer" @click="dialog.dialogQrisImage = true">
                        {{ $t('show_qris') }}
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-center pa-4 col-paymentleft">
                    <div class="paymentleft-title">
                      {{ $t('payment_time_left') }}
                    </div>
                    <v-spacer />
                    <div class="text-right">
                      <div class="paymentleft-subtitle-1">
                        {{ formattedTimeLeft }}
                      </div>
                      <div class="paymentleft-subtitle-2">
                        {{ order.payment_log.expired_at }}
                      </div>
                    </div>
                  </div>
                </div>
              </v-card>
              <v-btn large block outlined color="primary" class="text-none letter-spacing-normal font-weight-bold br-8" @click="dialog.dialogQrisGuide = true">
                {{ $t('view_payment_guide') }}
              </v-btn>
              <v-dialog v-model="dialog.dialogQrisImage" max-width="350">
                <v-card>
                  <div class="pa-4">
                    <div class="d-flex align-center mb-3">
                      <v-spacer />
                      <v-btn icon @click="dialog.dialogQrisImage = false">
                        <v-icon>
                          mdi-close
                        </v-icon>
                      </v-btn>
                    </div>
                    <div>
                      <div class="col-square mb-4">
                        <div class="content-square">
                          <img :src="order.payment_log.qr_image" alt="" class="image-qris">
                        </div>
                      </div>
                      <v-btn :href="order.payment_log.qr_image" download="QRIS.png" block color="primary" height="40" class="text-none">
                        <v-icon left>
                          mdi-download
                        </v-icon>
                        {{ $t('download_qris') }}
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialog.dialogQrisGuide" max-width="350">
                <v-card>
                  <div class="pa-4">
                    <div class="d-flex align-center mb-3">
                      <h4 class="font-18">
                        {{ $t('how_to_pay_qris') }}
                      </h4>
                      <v-spacer />
                      <v-btn icon @click="dialog.dialogQrisGuide = false">
                        <v-icon>
                          mdi-close
                        </v-icon>
                      </v-btn>
                    </div>
                    <div>
                      <div>
                        <ol class="qris-guide-list">
                          <li v-for="(step, index) in $t('how_to_pay_qris_steps')" :key="index">
                            {{ step }}
                          </li>
                        </ol>
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-dialog>
            </div>
          </div>

          <div v-if="!$isEmpty(order.payment_log) && order.payment_log.payment_source === 'VIRTUAL-ACCOUNT' && order.is_paid === 0" class="mb-4">
            <div>
              <v-card class="br-8 shadow-low mb-4">
                <div>
                  <div class="d-flex align-start pa-4">
                    <div class="order-va-icon mr-4">
                      <img :src="order.payment_log.payment_image" alt="">
                    </div>
                    <div>
                      <div class="order-va-title">
                        {{ order.payment_log.va_bank_code }}
                      </div>
                      <div class="order-va-subtitle">
                        {{ order.payment_log.va_account_number }}
                      </div>
                      <input id="va_account_number" type="hidden" :value="order.payment_log.va_account_number">
                      <div class="cursor-pointer cp-va-number" @click="copyVAaccount()">
                        {{ $t('copy_number') }}
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-center pa-4 col-paymentleft">
                    <div class="paymentleft-title">
                      {{ $t('payment_time_left') }}
                    </div>
                    <v-spacer />
                    <div class="text-right">
                      <div class="paymentleft-subtitle-1">
                        {{ formattedTimeLeft }}
                      </div>
                      <div class="paymentleft-subtitle-2">
                        {{ order.payment_log.expired_at }}
                      </div>
                    </div>
                  </div>
                </div>
              </v-card>
              <v-btn large block outlined color="primary" class="text-none letter-spacing-normal font-weight-bold br-8" @click="dialog.dialogGuide = true">
                {{ $t('view_payment_guide') }}
              </v-btn>
              <v-dialog v-model="dialog.dialogGuide" max-width="350">
                <v-card>
                  <div class="pa-4">
                    <div class="d-flex align-center mb-3">
                      <h4 class="font-18">
                        {{ $t('payment_guide') }}
                      </h4>
                      <v-spacer />
                      <v-btn icon @click="dialog.dialogGuide = false">
                        <v-icon>
                          mdi-close
                        </v-icon>
                      </v-btn>
                    </div>
                    <v-expansion-panels v-if="order.payment_log && order.payment_log.va_bank_code" flat class="panel-guide">
                      <template v-if="order.payment_log.va_bank_code === 'MANDIRI'">
                        <v-expansion-panel>
                          <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                            ATM
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ol>
                              <li v-for="(item, index) in $t('mandiri_atm_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                            </ol>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                          <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                            Mobile Banking
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ol>
                              <li v-for="(item, index) in $t('mandiri_mobile_banking_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                            </ol>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                          <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                            Internet Banking
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ol>
                              <li v-for="(item, index) in $t('mandiri_internet_banking_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                            </ol>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </template>
                      <template v-if="order.payment_log.va_bank_code === 'BNI'">
                        <v-expansion-panel>
                          <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                            ATM
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ol>
                              <li v-for="(item, index) in $t('bni_atm_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                            </ol>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                          <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                            Mobile Banking BNI
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ol>
                              <li v-for="(item, index) in $t('bni_mobile_banking_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                            </ol>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                          <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                            Internet Banking BNI
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ol>
                              <li v-for="(item, index) in $t('bni_internet_banking_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                            </ol>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </template>
                      <template v-if="order.payment_log.va_bank_code === 'BRI'">
                        <v-expansion-panel>
                          <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                            ATM
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ol>
                              <li v-for="(item, index) in $t('bri_atm_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                            </ol>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                          <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                            Mobile Banking
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ol>
                              <li v-for="(item, index) in $t('bri_mobile_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                            </ol>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                          <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                            Internet Banking
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ol>
                              <li v-for="(item, index) in $t('bri_internet_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                            </ol>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </template>
                      <template v-if="order.payment_log.va_bank_code === 'PERMATA'">
                        <v-expansion-panel>
                          <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                            ATM PRIMA / ALTO:
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ol>
                              <li v-for="(item, index) in $t('prima_atm_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                            </ol>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                          <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                            Permata Mobile X
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ol>
                              <li v-for="(item, index) in $t('permata_mobile_x_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                            </ol>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                          <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                            Permata Mobile
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ol>
                              <li v-for="(item, index) in $t('permata_mobile_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                            </ol>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                          <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                            Internet Banking Permata (PermataNet)
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ol>
                              <li v-for="(item, index) in $t('permata_ib_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                            </ol>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </template>
                      <template v-if="order.payment_log.va_bank_code === 'BCA'">
                        <v-expansion-panel>
                          <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                            ATM
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ol>
                              <li v-for="(item, index) in $t('bca_atm_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                            </ol>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                          <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                            IBanking
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ol>
                              <li v-for="(item, index) in $t('bca_internet_banking_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                            </ol>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                          <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                            BCA M-Mobile
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ol>
                              <li v-for="(item, index) in $t('bca_mobile_banking_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                            </ol>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </template>
                    </v-expansion-panels>
                  </div>
                </v-card>
              </v-dialog>
            </div>
          </div>

          <v-divider v-if="order.remark === 'DELIVERY' || order.remark === 'OL-TAKE-AWAY'" class="mt-1 mb-6" style="width: 100%;" />
          <template v-if="order.remark === 'DELIVERY'">
            <div class="d-flex">
              <div class="d-flex title-wrapper">
                <div class="__title-list">
                  {{ $t('delivery_option') }}
                  <span v-if="order.shipping_delivery_type === '1'" class="ml-1">
                    Restaurant Delivery
                  </span>
                  <span v-else-if="order.shipping_delivery_type === '2' && order.shipping_courier_id === 'S08'" class="ml-1">
                    Gosend
                  </span>
                  <span v-else-if="order.shipping_delivery_type === '2' && order.shipping_courier_id === 'S09'" class="ml-1">
                    Grab Express
                  </span>
                </div>
              </div>
            </div>
            <div class="d-flex mt-3">
              <div class="p-relative d-flex flex-column shipping-wrapper">
                <div class="__d-from align-center">
                  <div class="__d-from-pin mr-2">
                    <img src="@/assets/images/svg/marker.svg">
                  </div>
                  <span class="font-weight-bold">
                    {{ order.store_name }}
                  </span>
                </div>
                <div class="d-flex __d-shipping">
                  <div class="">
                    <div class="__d-from-pin mr-2">
                      <img src="@/assets/images/svg/destination.svg">
                    </div>
                  </div>
                  <div class="d-flex flex-column">
                    <div class="__d-shipping-radius">
                      {{ $t('delivery_location_distance', { order: { shipping_radius: order.shipping_radius } }) }}
                    </div>
                    <div class="__d-shipping-address font-weight-bold">
                      {{ order.shipping_address }}
                    </div>
                  </div>
                </div>
                <div class="__d-shipping-distance" />
              </div>
            </div>
          </template>
          <template v-else-if="order.remark === 'OL-TAKE-AWAY'">
            <div class="d-flex align-center justify-center">
              <div class="d-flex title-wrapper flex-column justify-center">
                <div class="d-flex __title-list justify-center mb-2">
                  {{ $t('take_away_time') }}
                </div>
                <div class="d-flex justify-center">
                  <span class="order-tag ml-1">
                    {{ order.ftake_time }}
                  </span>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="order.remark === 'OL-DINE-IN' & !isHotels">
            <div class="d-flex align-center justify-center">
              <div class="d-flex mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="18.301" height="15.251" viewBox="0 0 18.301 15.251" class="svg-table-cart">
                  <g id="surface1" transform="translate(-0.992 -3.473)">
                    <path id="Path_1" data-name="Path 1" d="M3.577,3.473a1.444,1.444,0,0,0,0,2.885,1.444,1.444,0,0,0,0-2.885Zm13.131,0A1.444,1.444,0,1,0,18.1,4.914,1.42,1.42,0,0,0,16.708,3.473ZM3.577,6.77A1.418,1.418,0,0,0,2.186,8.211l.006,4.242a1.419,1.419,0,0,0,1.385,1.321H4.758l.3-2.058H4.971l0-3.528A1.452,1.452,0,0,0,3.577,6.77Zm13.131,0a1.457,1.457,0,0,0-1.391,1.418l0,3.528h-.085l.3,2.058h1.181a1.417,1.417,0,0,0,1.385-1.321L18.1,8.211A1.418,1.418,0,0,0,16.708,6.77ZM1.384,7.176a.406.406,0,0,0-.392.419v5.891a1.63,1.63,0,0,0,.774,1.3l-.373,3.479a.4.4,0,1,0,.79.091l.36-3.343H5.385l-.41,2.824a.439.439,0,0,0,.05.269c.081.146.448.617,1.745.617a2.555,2.555,0,0,0,1.385-.315V15.424a.4.4,0,1,1,.8,0v3.012a2.21,2.21,0,0,0,1.194.286,2.219,2.219,0,0,0,1.194-.286V16.248a.4.4,0,1,1,.8,0V18.39a2.836,2.836,0,0,0,1.416.331,2.224,2.224,0,0,0,1.654-.539.426.426,0,0,0,.107-.347L14.9,15.011h2.845l.357,3.343a.407.407,0,0,0,.442.367.414.414,0,0,0,.351-.458l-.373-3.479a1.627,1.627,0,0,0,.771-1.3V7.595a.42.42,0,0,0-.116-.3.39.39,0,0,0-.288-.12.406.406,0,0,0-.392.419V13.44a.774.774,0,0,1-.768.746H14.781l-.664-4.593a.4.4,0,0,0-.395-.35H6.563a.405.405,0,0,0-.395.35L5.5,14.187H2.556a.774.774,0,0,1-.768-.746V7.595a.433.433,0,0,0-.116-.3A.4.4,0,0,0,1.384,7.176Z" transform="translate(0)" />
                  </g>
                </svg>
              </div>
              <div class="font-14 font-weight-bold primary--text">
                {{ $t('table') }} {{ order.table_no }}
              </div>
            </div>
          </template>
          <template v-else-if="order.remark === 'RESERVATION'">
            <div class="d-flex align-center">
              <div class="d-flex mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="svg-calender-cart">
                  <g id="Group_25940" data-name="Group 25940" transform="translate(-32 -501)">
                    <rect id="Rectangle_43012" data-name="Rectangle 4304" width="24" height="24" transform="translate(32 501)" fill="#fff" opacity="0" />
                    <path id="calendar_today_FILL0_wght400_GRAD0_opsz48" d="M7.282,21.088A1.314,1.314,0,0,1,6,19.806V6.563A1.314,1.314,0,0,1,7.282,5.282H8.67V4h1.388V5.282h7.262V4h1.388V5.282H20.1a1.314,1.314,0,0,1,1.282,1.282V19.806A1.314,1.314,0,0,1,20.1,21.088Zm0-1.282H20.1V10.622H7.282Zm0-10.466H20.1V6.563H7.282Zm0,0v0Z" transform="translate(30.31 500.456)" />
                  </g>
                </svg>
              </div>
              <div class="font-14 font-weight-bold primary--text">
                {{ formatReserveDate }}, {{ order.freserve_time }}
              </div>
            </div>
            <div class="d-flex align-center">
              <div class="d-flex mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="18.301" height="15.251" viewBox="0 0 18.301 15.251" class="ml-1 svg-table-cart">
                  <g id="surface1" transform="translate(-0.992 -3.473)">
                    <path id="Path_1" data-name="Path 1" d="M3.577,3.473a1.444,1.444,0,0,0,0,2.885,1.444,1.444,0,0,0,0-2.885Zm13.131,0A1.444,1.444,0,1,0,18.1,4.914,1.42,1.42,0,0,0,16.708,3.473ZM3.577,6.77A1.418,1.418,0,0,0,2.186,8.211l.006,4.242a1.419,1.419,0,0,0,1.385,1.321H4.758l.3-2.058H4.971l0-3.528A1.452,1.452,0,0,0,3.577,6.77Zm13.131,0a1.457,1.457,0,0,0-1.391,1.418l0,3.528h-.085l.3,2.058h1.181a1.417,1.417,0,0,0,1.385-1.321L18.1,8.211A1.418,1.418,0,0,0,16.708,6.77ZM1.384,7.176a.406.406,0,0,0-.392.419v5.891a1.63,1.63,0,0,0,.774,1.3l-.373,3.479a.4.4,0,1,0,.79.091l.36-3.343H5.385l-.41,2.824a.439.439,0,0,0,.05.269c.081.146.448.617,1.745.617a2.555,2.555,0,0,0,1.385-.315V15.424a.4.4,0,1,1,.8,0v3.012a2.21,2.21,0,0,0,1.194.286,2.219,2.219,0,0,0,1.194-.286V16.248a.4.4,0,1,1,.8,0V18.39a2.836,2.836,0,0,0,1.416.331,2.224,2.224,0,0,0,1.654-.539.426.426,0,0,0,.107-.347L14.9,15.011h2.845l.357,3.343a.407.407,0,0,0,.442.367.414.414,0,0,0,.351-.458l-.373-3.479a1.627,1.627,0,0,0,.771-1.3V7.595a.42.42,0,0,0-.116-.3.39.39,0,0,0-.288-.12.406.406,0,0,0-.392.419V13.44a.774.774,0,0,1-.768.746H14.781l-.664-4.593a.4.4,0,0,0-.395-.35H6.563a.405.405,0,0,0-.395.35L5.5,14.187H2.556a.774.774,0,0,1-.768-.746V7.595a.433.433,0,0,0-.116-.3A.4.4,0,0,0,1.384,7.176Z" transform="translate(0)" />
                  </g>
                </svg>
              </div>
              <div class="font-14 font-weight-bold primary--text">
                {{ order.total_guest }} {{ $t('table') }}
              </div>
            </div>
          </template>
          <template v-if="isHotels">
            <div class="d-flex mt-6">
              <div class="d-flex title-wrapper">
                <div class="__title-list">
                  {{ $t('item_detail') }}
                </div>
              </div>
            </div>
            <v-list two-line class="list-product">
              <template v-for="(item, idx) in order.items">
                <v-list-item :key="idx + '-product'">
                  <v-list-item-avatar class="list-img-square">
                    <img :src="item.product_combo_id === 0 ? item.product_photo_xs : item.product_combo_photo_xs" @error="imageLoadError">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.qty }}x - {{ item.item_name }} <span v-if="item.item_variant_name">({{ item.item_variant_name }})</span>
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="item.item_product_combo != '' && !$store.state.selected_outlet.hide_combo_item">
                      <template v-for="(child, key) in item.item_product_combo">
                        <span v-if="child.item_variant_name !== ''" :key="key">
                          {{ child.item_name }} ({{ child.item_variant_name }})
                        </span>
                        <span v-else :key="key">
                          {{ child.item_name }}
                        </span>
                        <span v-if="(item.item_product_combo.length - key) != 1" :key="key + '-plus'" v-html="'+'" />
                      </template>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="item.addon.length !== 0">
                      <template v-for="(addons_item, index) in item.addon">
                        {{ addons_item.name }}
                        <span v-if="(item.addon.length - index) !== 1" :key="index + '-plus'" v-html="'+'" />
                      </template>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="item.note !== ''">
                      <v-icon left color="grey lighten-1">
                        mdi-file-document-outline
                      </v-icon>
                      <span>
                        {{ item.note }}
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action class="text-right">
                    <v-list-item-subtitle class="font-weight-bold">
                      <span v-mask-money-only="item.amount" />
                    </v-list-item-subtitle>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-list>
          </template>
          <v-divider class="my-6" style="width: 100%;" />
          <div class="d-flex">
            <div class="d-flex title-wrapper">
              <div class="__title-list">
                {{ $t('order_detail') }}
              </div>
            </div>
          </div>
          <div class="__price-wrapper d-flex flex-column mt-3">
            <div class="__data-price">
              <h4>
                {{ $t('price') }}
              </h4>
              <v-spacer />
              <h4>
                {{ Math.round((order.order_amount) * 100) / 100 }}
              </h4>
            </div>
            <div v-if="order.discount_amount > 0" class="__data-price">
              <h4>
                {{ $t('discount') }}
                <span v-if="order.discount_voucher_code && order.discount_voucher_code !== ''">
                  ({{ order.discount_voucher_code }})
                </span>
              </h4>
              <v-spacer />
              <h4 class="color-price">
                - {{ Math.round((order.discount_amount) * 100) / 100 }}
              </h4>
            </div>
            <template v-if="order.remark === 'DELIVERY' || order.remark === 'OL-TAKE-AWAY'">
              <div v-if="order.trans_fee_rate !== '0.00'" class="__data-price">
                <h4>
                  {{ $t('convenience_fee') }} ({{ order.trans_fee_rate * 100 }}%)
                </h4>
                <v-spacer />
                <h4>
                  {{ Math.round(order.trans_fee_amount) }}
                </h4>
              </div>
              <div v-if="order.payment_charge !== '0.00'" class="__data-price">
                <h4>
                  {{ $t('payment_charge') }}
                </h4>
                <v-spacer />
                <h4>
                  {{ Math.round((order.payment_charge) * 100) / 100 }}
                </h4>
              </div>
              <template v-if="selected_outlet.pos_take_away_with_service_charge">
                <div v-if="order.service_charge_amount !== '0.00'" class="__data-price">
                  <h4>
                    {{ $t('service_charge') }}
                  </h4>
                  <v-spacer />
                  <h4>
                    {{ Math.round((order.service_charge_amount) * 100) / 100 }}
                  </h4>
                </div>
              </template>
            </template>
            <template v-else>
              <div v-if="order.remark === 'RESERVATION'" class="__data-price">
                <h4>
                  {{ $t('convenience_fee') }}
                </h4>
                <v-spacer />
                <h4>
                  {{ Number(order.trans_fee_amount) }}
                </h4>
              </div>
              <div v-if="order.service_charge_amount !== '0.00'" class="__data-price">
                <h4>
                  {{ $t('service_charge') }}
                </h4>
                <v-spacer />
                <h4>
                  {{ Math.round((order.service_charge_amount) * 100) / 100 }}
                </h4>
              </div>
            </template>
            <div v-if="Number(order.tax_amount) !== 0" class="__data-price">
              <h4>
                {{ $store.state.selected_outlet.tax_name ? $store.state.selected_outlet.tax_name : $t('v2.tax') }}
              </h4>
              <v-spacer />
              <h4>
                {{ Math.round((order.tax_amount) * 100) / 100 }}
              </h4>
            </div>
            <div v-if="order.remark === 'DELIVERY'" class="__data-price">
              <h4>
                {{ $t('delivery_fee') }}
              </h4>
              <v-spacer />
              <template v-if="order.shipping_cost === '0.00'">
                <h4>
                  {{ $t('free') }}
                </h4>
              </template>
              <h4 v-else v-mask-money="order.shipping_cost" />
            </div>
            <div v-if="order.redeemed_amount > 0" class="__data-price">
              <h4>
                {{ $t('redeemed_points', { points: Math.round(order.redeemed_points) }) }}
              </h4>
              <v-spacer />
              <h4>
                - {{ Math.round(order.redeemed_amount) }}
              </h4>
            </div>
            <div v-if="order.rounded_amount && Number(order.rounded_amount) !== 0" class="__data-price">
              <h4>
                {{ $t('rounding') }}
              </h4>
              <v-spacer />
              <h4>
                {{ Math.round(order.rounded_amount) }}
              </h4>
            </div>
            <v-divider class="ma-auto divider-dashed" style="width: 100%;" />
            <div class="__data-price font-weight-bold">
              <h4>
                Total
              </h4>
              <v-spacer />
              <h4 v-mask-money="order.total_amount" />
            </div>
            <v-divider class="ma-auto divider-dashed" style="width: 100%;" />
            <div class="__data-price">
              <span v-if="order.is_paid === 1" class="order-is-paid">
                {{ $t('status.already_paid') }}
              </span>
              <span v-else-if="order.is_paid === 0" class="order-is-unpaid">
                {{ $t('status.not_paid') }}
              </span>
            </div>
            <template v-if="$isEmpty(order.payment_log) && order.is_paid === 0">
              <v-divider class="ma-auto divider-dashed" style="width: 100%;" />
              <div class="__data-price">
                <h4 v-if="order.remark === 'DELIVERY' || $store.state.selected_type === 'OL-TAKE-AWAY'">
                  {{ $t('pay_after_receiving_the_order') }}
                </h4>
                <h4 v-else>
                  {{ $t('pay_at_the_cashier') }}
                </h4>
                <v-spacer />
                <h4 v-mask-money="order.total_amount" class="font-weight-bold" />
              </div>
            </template>
          </div>
          <v-divider class="my-6" style="width: 100%;" />
          <template v-if="!isHotels">
            <div class="d-flex">
              <div class="d-flex title-wrapper">
                <div class="__title-list">
                  {{ $t('item_detail') }}
                </div>
              </div>
            </div>
            <v-list two-line class="list-product">
              <template v-for="(item, idx) in order.items">
                <v-list-item :key="idx + '-product'">
                  <v-list-item-avatar class="list-img-square">
                    <img :src="item.product_combo_id === 0 ? item.product_photo_xs : item.product_combo_photo_xs" @error="imageLoadError">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.qty }}x - {{ item.item_name }} <span v-if="item.item_variant_name">({{ item.item_variant_name }})</span>
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="item.item_product_combo != '' && !$store.state.selected_outlet.hide_combo_item">
                      <template v-for="(child, key) in item.item_product_combo">
                        <span v-if="child.item_variant_name !== ''" :key="key">
                          {{ child.item_name }} ({{ child.item_variant_name }})
                        </span>
                        <span v-else :key="key">
                          {{ child.item_name }}
                        </span>
                        <span v-if="(item.item_product_combo.length - key) != 1" :key="key + '-plus'" v-html="'+'" />
                      </template>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="item.addon.length !== 0">
                      <template v-for="(addons_item, index) in item.addon">
                        {{ addons_item.name }}
                        <span v-if="(item.addon.length - index) !== 1" :key="index + '-plus'" v-html="'+'" />
                      </template>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="item.note !== ''">
                      <v-icon left color="grey lighten-1">
                        mdi-file-document-outline
                      </v-icon>
                      <span>
                        {{ item.note }}
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action class="text-right">
                    <v-list-item-subtitle class="font-weight-bold">
                      <span v-mask-money-only="item.amount" />
                    </v-list-item-subtitle>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-list>
          </template>
        </v-col>
      </v-row>
      <div v-if="isLastRefresh" class="__menu-bottom-transparent">
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
          <v-btn color="primary" x-large block class="text-none" @click="fetchOrder()">
            {{ $t('refresh') }}
          </v-btn>
        </v-col>
      </div>
    </v-container>
    <template v-if="order.status === 'P' && order.is_paid === 0">
      <v-divider class="ma-auto" style="width: 100%;" />
      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <v-btn color="primary" text x-large block class="text-none" @click="confirmCancel()">
              {{ $t('cancel_order') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-dialog v-model="dialog.dialogCancelOrder" max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ $t('confirm') }}
          </v-card-title>
          <v-card-text>
            {{ $t('are_you_sure_want_to_cancel_the_order') }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="grey" text @click="dialog.dialogCancelOrder = false">
              {{ $t('no') }}
            </v-btn>
            <v-btn color="primary" outlined @click="cancelOrder(order.id)">
              {{ $t('yes') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <v-dialog v-if="order.shipping_log && !$isEmpty(order.shipping_log.shipper) && order.shipping_log.shipper.status_code === '999'" v-model="dialog.dialogNoDriver" max-width="350">
      <v-card>
        <div class="pa-6 p-relative">
          <v-btn text icon class="btn-close-dialog" @click="dialog.dialogNoDriver = false">
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
          <div class="text-center">
            <v-img src="@/assets/images/no_driver.png" height="177" contain />
            <div class="font-16 font-weight-bold mb-2">
              {{ order.shipping_log.shipper.status_description }}
            </div>
            <div class="font-14 mb-6" style="color: #6A6A6A;">
              {{ $t('contact_restaurant_to_confirm_order') }}
            </div>
            <v-btn block outlined large color="primary" class="br-8 text-none" @click="dialog.dialogNoDriver = false">
              {{ $t('back') }}
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="dataSuccess.show" multi-line top color="success" :timeout="3000">
      {{ dataSuccess.message }}
      <v-btn class="transparent" text fab x-small dark @click="closeDataSuccess()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn class="transparent" text fab x-small dark @click="snackbar.show = false">
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbarCopy.show">
      {{ snackbarCopy.text }}
    </v-snackbar>
    <v-dialog v-model="dialog.tracking" persistent max-width="400">
      <v-card>
        <v-btn text icon class="btnTrackClose" @click="dialog.tracking = false">
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
        <div class="d-flex flex-full">
          <embed v-if="order.shipping_log && !$isEmpty(order.shipping_log.shipper) && order.shipping_log.shipper.live_tracking" type="text/html" :src="order.shipping_log.shipper.live_tracking" width="100%" height="600">
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { latLng } from 'leaflet'
import {
  getDataDetail as getDataDetailOutlet
} from '@/api/outlet'
import {
  getDataDetail as getDataDetailOrder,
  cancelOrder as cancelDataOrder
} from '@/api/order'
export default {
  data() {
    return {
      snackbarCopy: {
        show: false,
        text: ''
      },
      dataSuccess: {
        show: false,
        message: ''
      },
      dialog: {
        dialogQrisImage: false,
        dialogQrisGuide: false,
        dialogCancelOrder: false,
        dialogGuide: false,
        dialogNoDriver: false,
        tracking: false
      },
      selected_outlet: {},
      order: {},
      distance: 0,
      timerInterval: null,
      snackbar: {
        show: false,
        text: ''
      },
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 15,
      center: [0, 0],
      markerLatLng: [0, 0],
      markerLatLngStore: [0, 0],
      loopInterval: 0,
      isLastRefresh: false,
      timerOrderInterval: null
    }
  },
  computed: {
    isHotels() {
      const url_hotel = this.$store.state.store_hotels
      const url_id = this.$store.state.url_domain
      if (url_hotel.indexOf(url_id) !== -1) {
        return true
      }
      return false
    },
    isTMII() {
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain
      if (tmii_outlet.indexOf(url_id) !== -1) {
        return true
      } else {
        return false
      }
    },
    formattedTimeLeft() {
      let days = Math.floor(this.distance / (1000 * 60 * 60 * 24))
      let hours = Math.floor((this.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((this.distance % (1000 * 60)) / 1000)
      let result
      if (this.distance < 0) {
        result = 'EXPIRED'
      } else {
        days = days === 0 ? '' : days + ' Hari : '
        hours = hours < 10 ? hours === 0 ? '' : '0' + hours + ' Jam : ' : hours + ' Jam : '
        minutes = minutes < 10 ? '0' + minutes + ' Menit : ' : minutes + ' Menit : '
        seconds = seconds < 10 ? '0' + seconds + ' Detik' : seconds + ' Detik'
        result = days + hours + minutes + seconds
      }
      return result
    },
    formatReserveDate() {
      const d = new Date(this.order.reserve_date)
      var day = d.getDay()
      const date = d.getDate()
      var month = d.getMonth()
      const year = d.getFullYear()

      switch (day) {
        case 0: day = this.$t('date.sunday'); break
        case 1: day = this.$t('date.monday'); break
        case 2: day = this.$t('date.tuesday'); break
        case 3: day = this.$t('date.wednesday'); break
        case 4: day = this.$t('date.thursday'); break
        case 5: day = this.$t('date.friday'); break
        case 6: day = this.$t('date.saturday'); break
      }

      switch (month) {
        case 0: month = this.$t('date.january'); break
        case 1: month = this.$t('date.february'); break
        case 2: month = this.$t('date.march'); break
        case 3: month = this.$t('date.april'); break
        case 4: month = this.$t('date.may'); break
        case 5: month = this.$t('date.june'); break
        case 6: month = this.$t('date.july'); break
        case 7: month = this.$t('date.august'); break
        case 8: month = this.$t('date.september'); break
        case 9: month = this.$t('date.october'); break
        case 10: month = this.$t('date.november'); break
        case 11: month = this.$t('date.december'); break
      }

      return day + ', ' + date + ' ' + month + ' ' + year
    },
    showDetailDriver() {
      if (this.order.shipping_log && !this.$isEmpty(this.order.shipping_log.shipper)) {
        if (this.order.shipping_log.shipper.status_code === '1170') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    driverDetail() {
      let driver = {}
      if (this.order.shipping_log && !this.$isEmpty(this.order.shipping_log.shipper)) {
        if (this.order.shipping_log.shipper.driver !== '') {
          driver = typeof this.order.shipping_log.shipper.driver === 'string' ? JSON.parse(this.order.shipping_log.shipper.driver) : this.order.shipping_log.shipper.driver
        }
      }
      return driver
    },
    showSearchDriver() {
      let driver = {}
      if (this.order.shipping_log && !this.$isEmpty(this.order.shipping_log.shipper)) {
        if (this.order.shipping_log.shipper.driver !== '') {
          driver = typeof this.order.shipping_log.shipper.driver === 'string' ? JSON.parse(this.order.shipping_log.shipper.driver) : this.order.shipping_log.shipper.driver
        }
      }
      if (this.order.shipping_log && !this.$isEmpty(this.order.shipping_log.shipper)) {
        if (this.order.shipping_log.shipper.status_code === '1001' || (this.order.shipping_log.shipper.status_code === '1160' && driver.name === '')) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    shipperProcess() {
      if (this.order.shipping_log && !this.$isEmpty(this.order.shipping_log.shipper)) {
        if (this.order.shipping_log.shipper.status_code === '1160' || this.order.shipping_log.shipper.status_code === '1170' || this.order.shipping_log.shipper.status_code === '1180' || this.order.shipping_log.shipper.status_code === '2000') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    outForDelivery() {
      if (this.order.shipping_log && !this.$isEmpty(this.order.shipping_log.shipper)) {
        if (this.order.shipping_delivery_type === '2' && this.order.shipping_courier_id === 'S09') {
          if (this.order.shipping_log.shipper.status_code === '1170' || this.order.shipping_log.shipper.status_code === '1180' || this.order.shipping_log.shipper.status_code === '2000') {
            return true
          } else {
            return false
          }
        } else {
          if (this.order.shipping_log.shipper.status_code === '1180' || this.order.shipping_log.shipper.status_code === '2000') {
            return true
          } else {
            return false
          }
        }
      } else {
        return false
      }
    },
    isDelivered() {
      if (this.order.shipping_log && !this.$isEmpty(this.order.shipping_log.shipper)) {
        if (this.order.shipping_log.shipper.status_code === '2000') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  mounted() {
    this.fetchOrder()
    this.getQuery()
  },
  beforeDestroy() {
    clearInterval(this.timerOrderInterval)
  },
  methods: {
    fetchShipper() {
      const socket = window.io('https://socket.all.olsera.indociti.com/shipper', {
        withCredentials: true,
        extraHeaders: {
          'Authorization': 'kYzfJORMSFSVmHCEZCiEpcwC669ig6Ab'
        }
      })

      socket.on('connect', () => {
        console.log('socket connected to shipper')
      })

      socket.on('shipper-olsera', (msg) => {
        try {
          const response = JSON.parse(JSON.stringify(msg))
          this.order.shipping_log.shipper = response.data.detail
        } catch (error) {
          console.log(error)
        }
      })
    },
    getQuery() {
      if (!this.$isEmpty(this.$route.query) && typeof this.$route.query.status !== 'undefined' && this.$route.query.status === 'error') {
        this.$store.state.show_error = true
        this.$store.state.error_message = this.$route.query.message
        this.$store.state.error_type = 400
      }
    },
    imageLoadError(event) {
      event.target.src = require('@/assets/images/product_not_available.png')
    },
    onResize() {
      this.$refs.map.mapObject._onResize()
    },
    closeDataSuccess() {
      this.dataSuccess.show = false
    },
    goBack() {
      if (this.$store.state.selected_store.setting.no_auth_dinein) {
        const astra_outlet = this.$store.state.store_astra
        const tmii_outlet = this.$store.state.store_tmii
        const url_id = this.$store.state.url_domain
        if (tmii_outlet.indexOf(url_id) !== -1) {
          window.location.href = 'https://order.kulinertmii.id'
        } else if (astra_outlet.indexOf(url_id) !== -1) {
          window.location.href = 'https://zestloungemenaraastra.myolsera.com'
        } else {
          this.$router.push({ name: 'orders' }).catch(() => {})
        }
      } else {
        this.$router.push({ name: 'orders' }).catch(() => {})
      }
    },
    getExpiryTime(time) {
      var countDownDate = new Date(time).getTime()
      const _this = this
      this.timerInterval = setInterval(function() {
        var now = new Date().getTime()
        _this.distance = countDownDate - now
        if (_this.distance < 0) {
          clearInterval(_this.timerInterval)
        }
      }, 1000)
    },
    async loadOutlet(id) {
      try {
        const { data } = await getDataDetailOutlet(id)
        this.$store.state.loading_axios = false
        this.selected_outlet = data.data
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async fetchOrder() {
      try {
        let params = {}
        if (this.$store.state.selected_store.setting.no_auth_dinein) {
          params = {
            remark: 'OL-DINE-IN'
          }
        }
        const { data } = await getDataDetailOrder(this.$route.params.id, params)
        this.$store.state.loading_axios = false
        this.order = data.data
        this.$store.dispatch('updateHistoryOrder', this.order)
        this.loadOutlet(this.order.store_id)
        if (!this.$isEmpty(this.order.payment_log)) {
          const time = this.order.payment_log.expired_at
          await this.getExpiryTime(time)
        }
        if (this.order.remark === 'DELIVERY') {
          this.$nextTick(() => {
            const self = this
            self.$refs.map.setCenter([Number(this.order.shipping_lat), Number(this.order.shipping_lon)])
          })
        }
        this.markerLatLng = latLng(Number(this.order.shipping_lat), Number(this.order.shipping_lon))
        this.markerLatLngStore = latLng(Number(this.order.store_lat), Number(this.order.store_lon))
        if (this.order.shipping_log && !this.$isEmpty(this.order.shipping_log.shipper) && this.order.shipping_log.shipper.status_code === '999') {
          this.dialog.dialogNoDriver = true
        }

        if (this.order.status !== 'Z' && this.order.status !== 'X' && this.order.status !== 'P') {
          if (this.order.shipping_courier_id === 'S08' || this.order.shipping_courier_id === 'S09') {
            this.fetchShipper()
          }
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async fetchOrderRefresh() {
      try {
        let params = {}
        if (this.$store.state.selected_store.setting.no_auth_dinein) {
          params = {
            remark: 'OL-DINE-IN'
          }
        }
        const { data } = await getDataDetailOrder(this.$route.params.id, params)
        this.$store.state.loading_axios = false
        this.order = data.data
        if (!this.$isEmpty(this.order.payment_log)) {
          const time = this.order.payment_log.expired_at
          await this.getExpiryTime(time)
        }
        if (this.order.remark === 'DELIVERY') {
          this.$nextTick(() => {
            const self = this
            self.$refs.map.setCenter([Number(this.order.shipping_lat), Number(this.order.shipping_lon)])
          })
        }
        this.markerLatLng = latLng(Number(this.order.shipping_lat), Number(this.order.shipping_lon))
        this.markerLatLngStore = latLng(Number(this.order.store_lat), Number(this.order.store_lon))
        if (this.order.shipping_log && !this.$isEmpty(this.order.shipping_log.shipper) && this.order.shipping_log.shipper.status_code === '999') {
          this.dialog.dialogNoDriver = true
        }

        if (this.order.status === 'Z' || this.order.status === 'X' || this.order.status === 'P') {
          clearInterval(this.timerOrderInterval)
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    confirmCancel() {
      this.dialog.dialogCancelOrder = true
    },
    async cancelOrder(id) {
      try {
        let params = {}
        if (this.$store.state.selected_store.setting.no_auth_dinein) {
          params = {
            remark: 'OL-DINE-IN'
          }
        }
        await cancelDataOrder(id, params)
        this.$store.state.loading_axios = false
        this.dataSuccess.show = true
        this.dataSuccess.message = 'Pesanan berhasil dibatalkan'
        this.dialog.dialogCancelOrder = false
        if (this.$store.state.selected_store.setting.no_auth_dinein) {
          setTimeout(() => {
            const astra_outlet = this.$store.state.store_astra
            const tmii_outlet = this.$store.state.store_tmii
            const url_id = this.$store.state.url_domain

            if (tmii_outlet.indexOf(url_id) !== -1) {
              window.location.href = 'https://order.kulinertmii.id'
            } else if (astra_outlet.indexOf(url_id) !== -1) {
              window.location.href = 'https://zestloungemenaraastra.myolsera.com'
            } else {
              this.$router.push({ name: 'home' }).catch(() => {})
            }
          }, 3000)
        } else {
          setTimeout(() => this.$router.push({ name: 'orders' }).catch(() => {}), 3000)
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    copyVAaccount() {
      const testingCodeToCopy = document.querySelector('#va_account_number')
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()
      try {
        const successful = document.execCommand('copy')
        const msg = successful ? 'successful' : 'unsuccessful'
        this.snackbarCopy.show = true
        this.snackbarCopy.text = 'Number was copied ' + msg
      } catch (err) {
        this.snackbarCopy.show = true
        this.snackbarCopy.text = 'Oops, unable to copy'
      }
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    refreshData() {
      const _this = this
      this.timerOrderInterval = setInterval(function() {
        _this.loopInterval++
        _this.fetchOrderRefresh()
        if (_this.loopInterval === 5) {
          clearInterval(_this.timerOrderInterval)
          _this.isLastRefresh = true
        }
      }, 15000)
    }
  }
}
</script>
